<template>
  <div>
    <label class="g-mb-10">{{ label }}</label>
    <p><small v-if="smallLabel !== ''"><i>{{ smallLabel }}</i></small></p>
    <input :id="pickerId" class="form-control form-control-md rounded-0" type="input">
  </div>
</template>

<script>
import {onMounted, ref, toRefs, watch} from "vue";
import DateUtils from '../utils/dateutils';

export default {
  name: 'InputDate',
  props: {
    label: String,
    date: String,
    defaultToToday: Boolean,
    smallLabel: String
  },
  emit: ['dateChanged'],
  data() {
    return {}
  },
  setup(props, {emit}) {

    const {date, defaultToToday} = toRefs(props);
    const selectedDate = ref();
    const pickerId = ref('date_' + Math.random());
    const dateUtils = DateUtils;

    selectedDate.value = defaultToToday.value ? dateUtils.formatDate(new Date()) : date.value;

    //setup picker
    let picker = null;

    //watches
    const dateChanged = () => {

      selectedDate.value = date.value;
      picker.setDate(selectedDate.value, true);
    };

    watch(date, dateChanged);

    //mounted
    const initDatePicker = () => {

      const datePickerFields = document.getElementById(pickerId.value);
      const maxYearRange = new Date().getFullYear() + 10;

      picker = new Pikaday({
        field: datePickerFields,
        format: "DD/MM/YYYY",
        onSelect: function (date) {
          selectedDate.value = dateUtils.formatDate(date);
          emit("dateChanged", selectedDate.value);

        },
        yearRange: [1910, maxYearRange],
        minDate: new Date('1753-01-01T00:00:00') //Min value of datetime in SQL Server CE
      });

      picker.setDate(selectedDate.value, true); //don't call onSelect callback

    };

    onMounted(initDatePicker);

    return {
      selectedDate,
      pickerId
    }
  }
}
</script>
